import { render, staticRenderFns } from "./PrescriptionItemRadioSelectExtended.vue?vue&type=template&id=05857772&scoped=true"
import script from "./PrescriptionItemRadioSelectExtended.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemRadioSelectExtended.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05857772",
  null
  
)

export default component.exports